import { useMediaQuery } from '@lingoda/ui';
import { BookingView } from '@lingoda/booking';

export const useBookingView = () => {
    const isGrid = useMediaQuery((theme) => theme.breakpoints.down('smn'));
    const view = isGrid ? BookingView.Grid : BookingView.List;

    return [view] as const;
};
